export default { tripTypes: [] };